import {
    GivelifySelect,
    GivelifyTextField,
    GivelifyLabel,
} from '@givelify/givelify-ui';
import {
    GivelifyNotification,
    DesignTokens,
    GivelifyModalDefaultPaper,
    GivelifyLegacyColorPalette,
} from '@givelify/ui';
import { Grid, styled } from '@mui/material';

export const autoIntegrationModalPaper = styled(GivelifyModalDefaultPaper)(
    ({ theme }) => ({
        minHeight: 700,
        maxHeight: '100vh',
        overflow: 'auto',
        backgroundColor: DesignTokens.color.backgroundSecondary,
        padding: theme.spacing(3),
        [theme.breakpoints.down('mobile')]: {
            height: '100vh',
            padding: theme.spacing(2),
        },
    }),
);

export const F1ModalContent = styled('div')(({ theme }) => ({
    overflow: 'auto',
    maxWidth: 880,
    '& .header': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
}));

export const PotentialContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const DonorInfo = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: 10,
    backgroundColor: GivelifyLegacyColorPalette.neutralHoverGrey,
    border: `1px solid ${GivelifyLegacyColorPalette.neutralPlatinum}`,
    marginBottom: theme.spacing(3),
}));

export const RowItem = styled(Grid)(({ theme }) => ({
    paddingRight: theme.spacing(2),
}));

export const TextOverflow = styled(GivelifyLabel)(() => ({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
}));

export const ListF1Donors = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
    borderTop: `1px solid ${GivelifyLegacyColorPalette.neutralPlatinum}`,
    maxHeight: 280,
    overflow: 'auto',
}));

export const F1DonorInfo = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(1, 3),
    borderBottom: `1px solid ${GivelifyLegacyColorPalette.neutralPlatinum}`,
}));

export const ItalicText = styled(GivelifyLabel, {
    shouldForwardProp: (prop) => prop !== 'matchPercent',
})<{ matchPercent: number }>(({ matchPercent }) => ({
    fontStyle: 'italic',
    whiteSpace: 'unset',
    color:
        matchPercent >= 90
            ? GivelifyLegacyColorPalette.success
            : matchPercent >= 75 && matchPercent < 90
            ? GivelifyLegacyColorPalette.warning
            : GivelifyLegacyColorPalette.error,
}));

export const DonorAddress = styled(GivelifyLabel)(() => ({
    whiteSpace: 'unset',
}));

export const EnterF1IdContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const ErrorNotification = styled(GivelifyNotification)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export const EnterF1IdForm = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
});

export const EnterIdField = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(3),
}));

export const CreateProfileContent = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const CreateProfileForm = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const CreateProfileRow = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(5),
}));

export const SelectTypeCol = styled('div')(() => ({
    width: '40%',
}));

export const InfoCol = styled('div')(() => ({
    width: '60%',
}));

export const FullWidth = styled('div')(() => ({
    width: '100%',
}));

export const SelectType = styled(GivelifySelect)(({ theme }) => ({
    paddingRight: theme.spacing(4),
    marginBottom: theme.spacing(2),
    '& > div': {
        width: '100%',
        height: 48,
    },
    [theme.breakpoints.down('sm')]: {
        paddingRight: 0,
    },
}));

export const CreateInput = styled(GivelifyTextField)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export const SubmitProfile = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
}));

export const FlexCenterForm = styled('form')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
}));

export const ConfirmModalContent = styled('div')(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(0, 6),
}));

export const ModalTitle = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

export const ConfirmModalGroupButton = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(7),
    display: 'flex',
    justifyContent: 'center',
    '& button': {
        margin: theme.spacing(0, 2),
    },
}));
